import Badge, { badgeClasses } from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';

export default function MenuButton({ showBadge = false, badgeContent, ...props }) {
  return (
    <Badge
      color="error"
      variant={badgeContent ? 'standard' : 'dot'}
      badgeContent={badgeContent}
      invisible={!showBadge}
      sx={{ [`& .${badgeClasses.badge}`]: { right: 2, top: 2 } }}
    >
      <IconButton
        size="small"
        {...props}
        sx={{
          width: 46,
          height: 46,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1.5,
          bgcolor: 'background.default',
          ...(props.sx || {}),
        }}
      />
    </Badge>
  );
}
